function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.77 258.204C-23.54 165.039 33.443 37.745 130.468 6.194c16.992-5.71 55.931-10.698 73.882.522 26.58 16.614 10.149 71.602 33.862 132.156 25.957 66.128 99.641 74.179 90.806 136.895-6.51 46.211-40.29 66.347-72.012 77.008-95.97 32.36-215.494-5.797-247.238-94.571z",
  fill: "#489F9D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M262.509 41.8c20.798-10.005 42.263 6.672 44.83 26.493 2.568 19.821-12.571 35.564-32.073 35.601-19.502.037-33.554-52.088-12.757-62.093z",
  fill: "#3D72DF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M331.28 78.521l-9.613-2.136m9.143-15.936l-9.478 2.168m1.314-17.498l-7.554 5.818m10.19 42.104l-8.128-4.933",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgImgBgSlideshowFeatures4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 365,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMzIiBoZWlnaHQ9IjM2NSIgdmlld0JveD0iMCAwIDMzMyAzNjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05Ljc2OTE5IDI1OC4yMDRDLTIzLjUzOTggMTY1LjAzOSAzMy40NDM3IDM3Ljc0NTQgMTMwLjQ2OSA2LjE5MzlDMTQ3LjQ2MSAwLjQ4NDMyOSAxODYuNCAtNC41MDQwMSAyMDQuMzUxIDYuNzE2MTFDMjMwLjkzMSAyMy4zMzAxIDIxNC41IDc4LjMxNzcgMjM4LjIxMyAxMzguODcyQzI2NC4xNyAyMDUgMzM3Ljg1NCAyMTMuMDUxIDMyOS4wMTkgMjc1Ljc2N0MzMjIuNTA5IDMyMS45NzggMjg4LjcyOSAzNDIuMTE0IDI1Ny4wMDcgMzUyLjc3NUMxNjEuMDM3IDM4NS4xMzUgNDEuNTEzIDM0Ni45NzggOS43NjkxOSAyNTguMjA0WiIgZmlsbD0iIzQ4OUY5RCIvPgo8cGF0aCBkPSJNMjYyLjUwOSA0MS44MDA3QzI4My4zMDcgMzEuNzk1IDMwNC43NzIgNDguNDcxNiAzMDcuMzM5IDY4LjI5MjhDMzA5LjkwNyA4OC4xMTQgMjk0Ljc2OCAxMDMuODU3IDI3NS4yNjYgMTAzLjg5NEMyNTUuNzY0IDEwMy45MzEgMjQxLjcxMiA1MS44MDY0IDI2Mi41MDkgNDEuODAwN1oiIGZpbGw9IiMzRDcyREYiLz4KPHBhdGggZD0iTTMzMS4yOCA3OC41MjExTDMyMS42NjcgNzYuMzg0OU0zMzAuODEgNjAuNDQ5TDMyMS4zMzIgNjIuNjE3Mk0zMjIuNjQ2IDQ1LjExODlMMzE1LjA5MiA1MC45MzY2TTMyNS4yODIgOTMuMDQwOUwzMTcuMTU0IDg4LjEwNzgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgImgBgSlideshowFeatures4 as ReactComponent };